import axios from "../axios";
import auth from "./auth";

const Student = {
  updateGeneralInformation(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .put("students/update-student", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  updatePassword(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("users/change-password", data)
        // 🔒 Tour 69 (A3) : les autres appareils sont déconnectés, celui-ci garde sa session avec le nouveau jeton
        .then(({ data }) => {
          if (data?.token) auth.saveToken(data.token);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 📱 Numéro corrigé dans la zone de vérification (tour 68, B5) : { country_code, phone_number }
  savePhone(data) {
    return new Promise((resolve, reject) => {
      axios
        .put("users/phone", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  sendOTP() {
    return new Promise((resolve, reject) => {
      
      axios
        .post("users/send-otp")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  verifyOTP(otp) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("users/verify-otp", otp)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 🔒 Tour 69 (A3) : confirm = { password } ou { code } (compte sans mot de passe)
  deleteAccount(id, confirm) {
    return new Promise((resolve, reject) => {
      
      axios
        .deleteWith("students/delete-student", id, confirm)
        .then(({ data }) => {resolve(data);
        auth.destroyToken('distory')})
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getFavourite() {
    return new Promise((resolve, reject) => {
      
      axios
        .get("channel")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  addToFavCollection(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("channel/add-to-channel", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  deleteFavouriteCollection(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .delete("channel", id)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  upadateNotificationSetting(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("set-student-notification", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getClassHistory(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .get(`get-classes-history/${id}`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          err?.response?.status === 401 && auth?.destroyToken();
          reject(err);
        });
    });
  },
  takeClasses(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("take-class", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  createFavourite(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("channel", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 💶 Frais de service économisés avec Premium depuis le premier abonnement (tour 57) : { premium, since, saved, classes }
  getPremiumSavings() {
    return new Promise((resolve, reject) => {
      axios
        .get("subscription/premium-savings")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 💶 Page Premium (tour 57, public) : { fee_percent, hourly_rate, class_fee }, cours d'une heure au tarif médian
  getStudentOffer() {
    return axios
      .get("student-offer")
      .then(({ data }) => data || {})
      .catch(() => ({}));
  },
  getLevels() {
    return new Promise((resolve, reject) => {
      
      axios
        .get("get-user-level")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getStudentById(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .get(`/students/${id}`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getCommissionData() {
    return new Promise((resolve, reject) => {
        
      axios
        .get(`/get-commission`)
        .then(({ data }) => resolve(data))
        .catch((error) => {reject(error);
          error?.response?.status===401&&auth?.destroyToken();
        });
    });
  },
  getAdvertBySubject(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .get(`adverts/get-adverts-by-subject/${id}`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          err?.response?.status === 401 && auth?.destroyToken();
          reject(err);
        });
    });
  },
  exitWaitingRoom(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .put(`/exit-waiting-room/${id}`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          err?.response?.status === 401 && auth?.destroyToken();
          reject(err);
        });
    });
  },
  getWalletRefund() {
    return new Promise((resolve, reject) => {
      
      axios
        .post(`/students/refund-student-walllet`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          err?.response?.status === 401 && auth?.destroyToken();
          reject(err);
        });
    });
  },

  // --- NOUVELLE FONCTION POUR ANNULER UN COURS (CÔTÉ ÉLÈVE) ---
  cancelClassRequest(data) {
    return new Promise((resolve, reject) => {
      axios
        // ✅ ON MET LA VRAIE ROUTE ICI, EN PUT !
        .put("students/cancel-class", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          err?.response?.status === 401 && auth?.destroyToken();
          reject(err);
        });
    });
  },
  // 💶 Demande de remboursement d'un cours terminé, dans les 24 h (carte ou porte-monnaie)
  requestClassRefund(classId, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`students/classes/${classId}/refund-request`, data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          err?.response?.status === 401 && auth?.destroyToken();
          reject(err);
        });
    });
  },
  // 🛡️ Problème sur un cours terminé, dans les 24 h : la part du prof est gelée
  reportClassProblem(classId, reason) {
    return new Promise((resolve, reject) => {
      axios
        .post(`students/classes/${classId}/report-problem`, { reason })
        .then(({ data }) => resolve(data))
        .catch((err) => {
          err?.response?.status === 401 && auth?.destroyToken();
          reject(err);
        });
    });
  },

  getStudentStatistics(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .get(`students/statistics/${id}`) 
        .then(({ data }) => resolve(data))
        .catch((err) => {
          err?.response?.status === 401 && auth?.destroyToken();
          reject(err);
        });
    });
  },
  
}

export default Student;
